import React from "react";
import NumberFormat from "react-number-format";
import { Col, Form, FormInstance, Input, Row } from "antd";
import cep from "../../../../../../services/cep";
import {
  validationCep,
  validationFieldRequired,
  validationStateAddress,
} from "../../../../../../utils/formValidations";

interface IAddressFormProps {
  form: FormInstance;
  setLoading: (loading: boolean) => void;
  setIsValidAddressForm: (isValidAddressForm: boolean) => void;
}

const AddressForm: React.FC<IAddressFormProps> = ({
  form,
  setLoading,
  setIsValidAddressForm,
}) => {
  const getAddressSuggestion = (value: string) => {
    if (value?.length === 8) {
      setLoading(true);
      cep
        .get(`${value}/json`)
        .then((res) => {
          const data = res.data;

          if (data.cep) {
            form.setFieldsValue({
              street: data.logradouro,
              neighborhood: data.bairro,
              city: data.localidade,
              state: data.uf,
            });
          } else {
            throw Error();
          }
        })
        .catch(() => {
          form.setFieldsValue({
            street: undefined,
            neighborhood: undefined,
            city: undefined,
            state: undefined,
            number: undefined,
          });
        })
        .finally(() => {
          onFieldsChange();
          setLoading(false);
        });
    }
  };

  const onFieldsChange = () => {
    form
      .validateFields()
      .then(() => setIsValidAddressForm(true))
      .catch(() => setIsValidAddressForm(false));
  };

  return (
    <>
      <Form
        form={form}
        size="large"
        layout="vertical"
        onChange={onFieldsChange}
      >
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item name="cep" label="CEP" rules={validationCep}>
              <NumberFormat
                mask="_"
                defaultValue=""
                format="#####-###"
                className="ant-input ant-input-lg"
                onValueChange={(value) => getAddressSuggestion(value?.value)}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="street"
              label="Logradouro"
              rules={validationFieldRequired}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={8}>
          <Col span={12}>
            <Form.Item
              name="neighborhood"
              label="Bairro"
              rules={validationFieldRequired}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="number"
              label="Número"
              rules={validationFieldRequired}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={8}>
          <Col span={12}>
            <Form.Item
              name="city"
              label="Cidade"
              rules={validationFieldRequired}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="state"
              label="Estado"
              rules={validationStateAddress}
            >
              <Input maxLength={2} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default AddressForm;
